import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LobConfig, Local, SubLobConfig } from '@cmi/shared/models';
import {
  COMPANY_DISABLED,
  COMPANY_ENABLED,
  COMPANY_FEATURE_KEY,
  CompanyState
} from '@cmi/store/admin/company';
import { LOCAL_GLOBAL_INTERNATIONAL, LOCAL_US } from '@cmi/store/app';

export const selectCompanyState = createFeatureSelector<CompanyState>(COMPANY_FEATURE_KEY);

export const selectCompanySelectedTab = createSelector(
  selectCompanyState,
  (state) => state.selectedTab
);
export const selectCompanyPeriods = createSelector(selectCompanyState, (state) => state.periods);
export const selectCompanyName = createSelector(selectCompanyState, (state) => state.name ?? '');
export const selectCompanyStatus = createSelector(selectCompanyState, (state) =>
  state.isEnabled ? COMPANY_ENABLED : COMPANY_DISABLED
);
export const selectCompanyLobConfigs = createSelector(selectCompanyState, (state) =>
  state.lobs.reduce((lobConfigs, lob) => {
    const subLobConfig = {
      subLobId: lob.subLobId,
      config: {
        id: `sublob${lob.subLobId}`,
        label: lob.subLobName
      }
    } as SubLobConfig;

    const lobConfig = lobConfigs.find((lobConfig) => lobConfig.lobId === lob.lobId);

    if (lobConfig) {
      lobConfig.subLobConfigs.push(subLobConfig);
    } else {
      lobConfigs.push({
        lobId: lob.lobId,
        lobName: lob.lobName,
        local: lob.local === Local.Global ? LOCAL_GLOBAL_INTERNATIONAL : LOCAL_US,
        subLobConfigs: [subLobConfig]
      } as LobConfig);
    }

    return lobConfigs;
  }, [] as LobConfig[])
);
export const selectCompanySelectedLobs = createSelector(selectCompanyState, (state) =>
  state.id ? (state.selectedLobs ?? []) : state.selectedLobs
);
export const selectCompanyValues = createSelector(selectCompanyState, (state) => ({
  name: state.name ?? '',
  pdfCoverTitle: state.pdfCoverTitle,
  logoFile: state.logoFile,
  template: state.template,
  startPeriodId: state.startPeriodId,
  endPeriodId: state.endPeriodId,
  status: state.isEnabled
}));
export const selectCompanySaveDisabled = createSelector(
  selectCompanyState,
  (state) =>
    !state.name ||
    state.originalValues ===
      JSON.stringify({
        name: state.name,
        pdfCoverTitle: state.pdfCoverTitle,
        logoPath: state.logoPath,
        template: state.template,
        startPeriodId: state.startPeriodId,
        endPeriodId: state.endPeriodId,
        isEnabled: state.isEnabled,
        selectedLobs: state.selectedLobs
      })
);
export const selectCompanyStatusDisabled = createSelector(
  selectCompanyState,
  (state) =>
    !state.name ||
    !state.pdfCoverTitle ||
    !state.logoPath ||
    !state.template ||
    !state.startPeriodId ||
    (!!state.selectedLobs && state.selectedLobs.length === 0)
);
export const selectCompanyRoleName = createSelector(
  selectCompanyState,
  (state) => state.roleName ?? ''
);
